import React, { Component } from 'react';
import { Button, FormItem, TextArea } from 'carbon-components-react';
import { RadioGroup, Radio } from 'react-radio-group';
import moment from 'moment';
import { StepCard } from '..';
import CancelModal from '../Modal/CancelModal';

class Filters extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedValue: props.selectedValue,
      descricaoOutroCriterio:
        (props.campaignItem && props.campaignItem.descricaoOutroCriterio) || '',
      cancelModal: false,
      isEdited: false
    };
  }

  onChangeFilter = value => {
    this.setState({ selectedValue: value, isEdited: true }, () => {
      this.cleanValues()
    });
  };

  onChangeText = event => {
    this.setState({ [event.target.id]: event.target.value, isEdited: true });
  };

  toggleCancelModal = () => {
    this.setState(prevState => ({ cancelModal: !prevState.cancelModal }));
  };

  canSave = () => {
    const {
      selectedValue,
      descricaoOutroCriterio,
    } = this.state;

    if (
      selectedValue === 'outroCriterio' &&
      descricaoOutroCriterio.length < 20
    ) {
      return false;
    }
    if (!selectedValue) {
      return false;
    }

    return true;
  };

  save = async () => {
    const { saveStep } = this.props;
    const {
      selectedValue,
      descricaoOutroCriterio,
    } = this.state;

    await saveStep({
      [selectedValue]: true,
      descricaoOutroCriterio,
      salvouFiltros: true
    });
    this.stepCardRef.toggleContent();
  };

  cleanValues = () => {
    const {
      selectedValue,
    } = this.state;

    if ( selectedValue !== 'outroCriterio') {
      this.setState({
        descricaoOutroCriterio: "",
      })
    }
  }

  requestCancel = () => {
    const { isEdited } = this.state;

    if (isEdited) {
      this.toggleCancelModal();
    } else {
      this.cancel();
    }
  };

  cancel = () => {
    const { selectedValue,campaignItem } = this.props;
    this.setState({
      selectedValue,
      isEdited: false,
      cancelModal: false
    }, () => {
      this.setState({
        selectedValue,
        descricaoOutroCriterio:
          (campaignItem && campaignItem.descricaoOutroCriterio) || '',
        cancelModal: false,
        isEdited: false        
      })
    });
    this.stepCardRef.toggleContent();
  };

  renderDescription = () => {
    const { step, selectedValue } = this.props;

    if (selectedValue === 'ativos') {
      return (
        <p className="font-size-13" style={{ color: '#36474f' }}>
          <strong>Comunicados sobre o cartão</strong>
        </p>
      );
    }
    if (selectedValue === 'nuncaCompraram') {
      return (
        <p className="font-size-13" style={{ color: '#36474f' }}>
          <strong>Incentivo à primeira compra</strong>
        </p>
      );
    }
    if (selectedValue === 'sentimosSuaFalta') {
      return (
        <p className="font-size-13" style={{ color: '#36474f' }}>
          <strong>Incentivo ao uso do cartão</strong>
        </p>
      );
    }
    if (selectedValue === 'outroCriterio') {
      return (
        <p className="font-size-13" style={{ color: '#36474f' }}>
          <strong>Outros (não contempla campanha de cobrança)</strong>
        </p>
      );
    }

    return step.description;
  };

  render() {
    const {
      selectedValue,
      descricaoOutroCriterio,
      cancelModal
    } = this.state;
    const { step, campaignItem, disabled, showSave } = this.props;
    const isFinished = campaignItem && campaignItem.salvouFiltros;

    return (
      <StepCard
        onRef={ref => {
          this.stepCardRef = ref;
        }}
        title={step.title}
        description={this.renderDescription()}
        isFinished={isFinished}
        disabled={disabled}
      >
        <div className="bx--grid">
          <div className="bx--row">
            <RadioGroup
              className="bx--radio-group"
              selectedValue={selectedValue}
              onChange={this.onChangeFilter}
            >
              <div>
                <Radio
                  id="filter-1"
                  className="bx--radio-button"
                  value="ativos"
                />
                <label htmlFor="filter-1" className="bx--radio-button__label">
                  <span className="bx--radio-button__appearance" />
                  <strong>Comunicados sobre o cartão</strong>
                </label>
                {selectedValue === 'ativos' && (
                  <div className="h-lg-margin">
                    <div className="bx--form__helper-text v-sm-margin">
                      Mensagens gerais sobre o cartão, destinados a clientes ativos. Nessa base, recebem a mensagem clientes que estão com status de associado liberado e com o cartão liberado ou inativo (ainda não desbloqueou), com registro de compra nos últimos 3 meses e com limite disponível.
                      <br /><br />
                      - Status de Associado é Liberado;
                      <br />
                      - Status do Cartão é Liberado ou Inativo;
                      <br />
                      - Com compra nos últimos 3 meses;
                      <br />
                      - Limite disponível de R$50 ou mais.
                    </div>
                  </div>
                )}
              </div>
              
              <div>
                <Radio
                  id="filter-2"
                  className="bx--radio-button"
                  value="nuncaCompraram"
                />
                <label htmlFor="filter-2" className="bx--radio-button__label">
                  <span className="bx--radio-button__appearance" />
                  <strong>Incentivo à primeira compra</strong>
                </label>
                {selectedValue === 'nuncaCompraram' && (
                  <div className="h-lg-margin">
                    <div className="bx--form__helper-text v-sm-margin">
                      Disparos para clientes que nunca realizaram uma compra. Nessa base, recebem a mensagem clientes com status de conta liberada ou inativa que nunca compraram (nem no cartão provisório) e que emitiram o cartão até 6 meses atrás.
                      <br /><br />
                      - Cliente sem registro de compra;
                      <br />
                      - Status de Associado é Liberado;
                      <br />
                      - Status do cartão é Liberado ou Inativo;
                      <br />
                      - Emissão do cartão até 6 meses atrás.
                    </div>
                  </div>
                )}
              </div>

              <div>
                <Radio
                  id="filter-3"
                  className="bx--radio-button"
                  value="sentimosSuaFalta"
                />
                <label htmlFor="filter-3" className="bx--radio-button__label">
                  <span className="bx--radio-button__appearance" />
                  <strong>Incentivo ao uso do cartão</strong>
                </label>
                {selectedValue === 'sentimosSuaFalta' && (
                  <div className="h-lg-margin">
                    <div className="bx--form__helper-text v-sm-margin">
                      Disparos para clientes que já realizaram alguma compra e queremos estimular a retenção, ou seja, o uso recorrente do cartão. Nessa base, recebem mensagens clientes com status de associado liberado, sem compra nos últimos 3 meses – mas com registro de compra nos últimos 12 meses – e sem fatura em atraso.
                      <br /><br />
                      - Status de Associado é Liberado;
                      <br />
                      - Status do cartão é Liberado ou Inativo;
                      <br />
                      - Com compra nos últimos 12 meses mas SEM compra nos 3 meses.
                    </div>
                  </div>
                )}
              </div>

              <div>
                <Radio
                  id="filter-4"
                  className="bx--radio-button"
                  value="outroCriterio"
                />
                <label htmlFor="filter-4" className="bx--radio-button__label">
                  <span className="bx--radio-button__appearance" />
                  <strong>Outros (não contempla campanha de cobrança)</strong>
                </label>
                {selectedValue === 'outroCriterio' && (
                  <div className="h-lg-margin">
                    <div className="bx--form__helper-text v-sm-margin">
                      Escolha esse filtro apenas se a estratégia da mensagem exigir um combinado de filtros específicos. Será preciso informar todos os filtros necessários tais como:
                      <br />
                      <br />
                      - Qual será o status de associado;
                      <br />
                      - Qual será o status do cartão;
                      <br />
                      - Critérios comportamentais (Período de compra específico, acessa ou não a canais digitais, possui ou não produtos do cartão e etc).
                      <br />
                      <br />
                      Atenção aos critérios solicitados pois esse formato pode ter alto risco de impacto negativo.
                    </div>
                    <FormItem>
                      <TextArea
                        id="descricaoOutroCriterio"
                        labelText="Descreva"
                        onChange={this.onChangeText}
                        value={descricaoOutroCriterio}
                        placeholder="Exemplo: Associado com status liberado, com compra no período de 3 meses, cartão com status liberado ou bloqueado por limite, com Ecofatura, e sem acesso à Área do cliente dentro de 3 meses."
                        invalidText="Preencha uma descrição com no mínimo 20 caracteres"
                        invalid={descricaoOutroCriterio.length < 20}
                      />
                    </FormItem>
                  </div>
                )}
              </div>
            </RadioGroup>
          </div>
          <div className="bx--row">
          {!!showSave && (
            <div className="bx--col-xs-12 bx--col-sm-6 v-md-margin">
              <Button onClick={this.save} disabled={!this.canSave()}>
                Salvar
              </Button>
              <Button
                kind="ghost"
                className="h-sm-margin"
                onClick={this.requestCancel}
              >
                Cancelar
              </Button>
            </div>
            )}
          </div>
          <CancelModal
            open={cancelModal}
            onOk={this.cancel}
            onCancel={this.toggleCancelModal}
          />
        </div>
      </StepCard>
    );
  }
}

export default Filters;



// WEBPACK FOOTER //
// ./src/components/campaigns/Filters.js